var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"dense":""}},[_c('v-col',[_c('tabella-distinta',{attrs:{"documento":_vm.item,"trigger":_vm.trigger}})],1),_c('v-col',[_c('grafico-distinta',{attrs:{"documento":_vm.item,"trigger":_vm.trigger}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }